import * as React from 'react';
import { FilterSelector } from '../../assets/FilterSelector/FilterSelector';

const styles = require('./Filters.css');

export class Filters extends React.Component<{}, {}>{
    render() {
        return (
            <div className={styles.filters}>
                <div className={styles.filterContainer}>

                    <h2 className={styles.title}>
                        Filters

                        <a href="#" className={styles.reset}>
                            Reset All
                        </a>
                    </h2>

                    <div className={styles.searchBar}>
                        <input type="text" placeholder="Search by Document Type, Fund Name, ISIN, Document Name, Language, Asset Class..." />
                        <button type="submit">Search</button>
                    </div>

                    <section className={styles.filterSelection}>

                        <FilterSelector type={"asset class"} />
                        <FilterSelector type={"type"} />
                        <FilterSelector type={"domicile"} />
                    </section>

                    <div className={styles.labels}>
                        <label>Asset Class: </label>
                    </div>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/Filters/Filters.tsx